import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.7812 7.875C13.7812 7.48339 13.6257 7.10782 13.3488 6.83091C13.0719 6.554 12.6963 6.39844 12.3047 6.39844H9.84375C9.84375 6.92058 9.63633 7.42134 9.26712 7.79055C8.8979 8.15977 8.39714 8.36719 7.875 8.36719C7.35286 8.36719 6.8521 8.15977 6.48288 7.79055C6.11367 7.42134 5.90625 6.92058 5.90625 6.39844H3.44531C3.0537 6.39844 2.67813 6.554 2.40123 6.83091C2.12432 7.10782 1.96875 7.48339 1.96875 7.875M13.7812 7.875V11.8125C13.7812 12.2041 13.6257 12.5797 13.3488 12.8566C13.0719 13.1335 12.6963 13.2891 12.3047 13.2891H3.44531C3.0537 13.2891 2.67813 13.1335 2.40123 12.8566C2.12432 12.5797 1.96875 12.2041 1.96875 11.8125V7.875M13.7812 7.875V5.90625M1.96875 7.875V5.90625M13.7812 5.90625C13.7812 5.51464 13.6257 5.13907 13.3488 4.86216C13.0719 4.58525 12.6963 4.42969 12.3047 4.42969H3.44531C3.0537 4.42969 2.67813 4.58525 2.40123 4.86216C2.12432 5.13907 1.96875 5.51464 1.96875 5.90625M13.7812 5.90625V3.9375C13.7812 3.54589 13.6257 3.17032 13.3488 2.89341C13.0719 2.6165 12.6963 2.46094 12.3047 2.46094H3.44531C3.0537 2.46094 2.67813 2.6165 2.40123 2.89341C2.12432 3.17032 1.96875 3.54589 1.96875 3.9375V5.90625",
      stroke: "currentColor",
      "stroke-width": "1.4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }